<template>
  <div class="md-layout" id="program-template-criteria">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">
            {{
              $t("management_program_template_criteria.title", {
                name: title
              })
            }}
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="mtc-table">
            <colgroup>
              <col span="1" style="width: 5%;" />
              <col span="1" style="width: 30%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 10%;" />
              <col span="1" style="width: 17%;" />
              <col span="1" style="width: 8%;" />
            </colgroup>
            <tbody>
              <tr class="mtc-table-row mtc-table-heading-row">
                <td class="mtc-table-col mtc-table-heading-col">
                  <p class="mtc-table-head-label mtc-table-head-label-choose">
                    {{ $t("common.choose") }}
                  </p>
                </td>
                <td
                  class="mtc-table-col mtc-table-heading-col"
                  v-for="(label, index) in columns"
                  :key="'mtc-' + index"
                >
                  <p class="mtc-table-head-label">
                    {{ label }}
                  </p>
                </td>
                <td class="mtc-table-col mtc-table-heading-col">
                  <p class="mtc-table-head-label">
                    {{ $t("common.actions") }}
                  </p>
                </td>
              </tr>

              <!--    Criteria Category    -->
              <template v-for="(category, categoryIndex) in tableData">
                <tr
                  class="mtc-table-row mtc-table-category-row"
                  :key="'mtc-category-item-' + categoryIndex"
                >
                  <td
                    class="mtc-table-col"
                    :key="'mtc-table-cell-category-' + categoryIndex"
                  >
                    <div class="mtc-table-checkbox">
                      <md-field>
                        <md-checkbox v-model="category.selected"></md-checkbox>
                      </md-field>
                    </div>
                  </td>
                  <template
                    v-for="(categoryData, categoryDataName) in category"
                  >
                    <td
                      class="mtc-table-col"
                      v-if="isDisplay(categoryDataName)"
                      :key="'mtc-table-cell-' + categoryDataName"
                      @click="displayCriteria(category)"
                    >
                      <div
                        class="mtc-table-content-col"
                        v-if="categoryDataName === 'name'"
                      >
                        <p class="mtc-table-cell">
                          {{ categoryData }}
                        </p>
                        <md-tooltip
                          md-direction="top"
                          v-if="category.description"
                          >{{ category.description }}</md-tooltip
                        >
                      </div>
                      <div v-else-if="categoryDataName === 'weight'">
                        <p
                          v-if="calcCategoryWeight(category) > 0"
                          class="mtc-category-weight"
                        >
                          {{ calcCategoryWeight(category) }}
                        </p>
                      </div>
                      <div
                        v-else-if="
                          categoryDataName === 'benchmark' ||
                            categoryDataName === 'min_point' ||
                            categoryDataName === 'unit'
                        "
                      ></div>
                      <div
                        v-else-if="categoryDataName === 'achievement_options'"
                      ></div>
                      <div v-else>
                        <p class="mtc-table-cell">
                          {{ categoryData }}
                        </p>
                      </div>
                    </td>
                  </template>
                  <td class="mtc-table-col mtc-table-actions">
                    <md-button
                      class="md-success md-actions-btn"
                      type="button"
                      v-if="
                        category.selected !==
                          oldTableData[categoryIndex].selected
                      "
                      @click.native="
                        updateProgramTemplateCriteriaCategory(
                          category,
                          categoryIndex
                        )
                      "
                    >
                      {{ $t("common.save") }}
                    </md-button>
                  </td>
                </tr>

                <!--    Criteria    -->
                <template
                  v-for="(criteria, criteriaIndex) in category.criteria"
                >
                  <tr
                    class="mtc-table-row mtc-table-child-row"
                    :key="
                      'mtc-child-item-' + categoryIndex + '' + criteriaIndex
                    "
                    v-show="category.showCriteria"
                  >
                    <td
                      class="mtc-table-col"
                      :key="'mtc-table-cell-child-' + criteriaIndex"
                    >
                      <div class="mtc-table-checkbox">
                        <md-field>
                          <md-checkbox
                            v-model="criteria.selected"
                            :disabled="!category.selected"
                          ></md-checkbox>
                        </md-field>
                      </div>
                    </td>
                    <template
                      v-for="(criteriaData, criteriaDataName) in criteria"
                    >
                      <td
                        class="mtc-table-col"
                        v-if="isDisplay(criteriaDataName)"
                        :key="'mtc-table-cell-' + criteriaDataName"
                      >
                        <div
                          class="mtc-table-content-col"
                          v-if="criteriaDataName === 'name'"
                        >
                          <p class="mtc-table-cell">
                            {{ criteriaData }}
                          </p>
                          <md-tooltip
                            md-direction="top"
                            v-if="criteria.description"
                            >{{ criteria.description }}</md-tooltip
                          >
                        </div>
                        <div
                          v-else-if="
                            criteriaDataName === 'weight' ||
                              criteriaDataName === 'benchmark' ||
                              criteriaDataName === 'min_point'
                          "
                        >
                          <input
                            class="mtc-table-input"
                            min="0"
                            type="number"
                            :disabled="!category.selected || !criteria.selected"
                            v-model="criteria[criteriaDataName]"
                          />
                        </div>
                        <div v-else-if="criteriaDataName === 'unit'">
                          <input
                            class="mtc-table-input"
                            type="text"
                            :disabled="!category.selected || !criteria.selected"
                            v-model="criteria[criteriaDataName]"
                          />
                        </div>
                        <div
                          v-else-if="criteriaDataName === 'achievement_options'"
                        >
                          <vue-tags-input
                            :disabled="!category.selected || !criteria.selected"
                            v-model="criteria.tag"
                            :tags="criteria.achievement_options_tags"
                            type-input="number"
                            @tags-changed="
                              newTags =>
                                (criteria.achievement_options_tags = newTags)
                            "
                            :placeholder="
                              $t(
                                'management_template_criteria.type_achievement_options'
                              )
                            "
                          ></vue-tags-input>
                        </div>
                        <div v-else>
                          <p class="mtc-table-cell">
                            {{ criteriaData }}
                          </p>
                        </div>
                      </td>
                    </template>
                    <td class="mtc-table-col mtc-table-actions">
                      <md-button
                        class="md-success md-actions-btn"
                        type="button"
                        v-if="
                          displayCriteriaSaveBtn(
                            criteria,
                            category,
                            categoryIndex,
                            criteriaIndex
                          )
                        "
                        @click.native="
                          updateProgramTemplateCriteria(
                            criteria,
                            categoryIndex,
                            criteriaIndex
                          )
                        "
                      >
                        {{ $t("common.save") }}
                      </md-button>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </md-card-content>
        <md-card-actions class="text-center submit-save-all-actions ">
          <md-button type="submit" class="md-success" @click="updateAll"
            >{{ $t("common.save_all") }}
          </md-button>
          <md-button native-type="button" @click="cancel"
            >{{ $t("common.cancel") }}
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { ProgramTemplateService } from "../../../services/programTemplate.service";
import _ from "lodash";
import { ProgramTemplateCriteriaService } from "../../../services/programTemplateCriteria.service";
import { ProgramTemplateCriteriaCategoryService } from "../../../services/programTemplateCriteriaCategory.service";
import $ from "jquery";
import VueTagsInput from "../../../components/Inputs/vue-tags-input/vue-tags-input";

export default {
  name: "ProgramTemplateCriteria",
  data() {
    return {
      title: "",
      perPageOptions: [5, 10, 25, 50],
      programTemplateInfo: {},
      tableData: [],
      oldTableData: [],
      pagination: {
        perPage: 10,
        from: 0,
        to: 0,
        total: 0,
        currentPage: 0
      },
      columns: {
        name: this.$t("management_program_template_criteria.name"),
        weight: this.$t("management_program_template_criteria.weight"),
        min_point: this.$t("management_program_template_criteria.min_point"),
        benchmark: this.$t("management_program_template_criteria.benchmark"),
        unit: this.$t("management_program_template_criteria.unit"),
        achievement_options: this.$t(
          "management_program_template_criteria.achievement_options"
        )
      }
    };
  },
  components: { VueTagsInput },
  created() {
    this.getDetailProgramTemplate();
    this.getTableData();
  },
  methods: {
    async getTableData() {
      let tableData = await new ProgramTemplateService().getListProgramTemplateCriteriaByUniId(
        this.$route.params.id
      );
      tableData.forEach(templateCriteriaCategory => {
        templateCriteriaCategory.selected = !_.isEmpty(
          templateCriteriaCategory.u_t_c_c
        );
        templateCriteriaCategory.weight = !_.isEmpty(
          templateCriteriaCategory.u_t_c_c
        )
          ? parseFloat(templateCriteriaCategory.u_t_c_c.weight)
          : 0;
        templateCriteriaCategory.min_point = null;
        templateCriteriaCategory.benchmark = null;
        templateCriteriaCategory.unit = null;
        templateCriteriaCategory.showCriteria = true;
        templateCriteriaCategory.achievement_options = null;
        templateCriteriaCategory.criteria.forEach(criteriaItem => {
          criteriaItem.selected = !_.isEmpty(criteriaItem.template);
          criteriaItem.weight = !_.isEmpty(criteriaItem.template)
            ? criteriaItem.template.weight
            : null;
          criteriaItem.min_point = !_.isEmpty(criteriaItem.template)
            ? criteriaItem.template.min_point
            : null;
          criteriaItem.benchmark = !_.isEmpty(criteriaItem.template)
            ? criteriaItem.template.benchmark
            : null;
          criteriaItem.unit = !_.isEmpty(criteriaItem.template)
            ? criteriaItem.template.unit
            : null;
          criteriaItem.achievement_options = !_.isEmpty(criteriaItem.template)
            ? this.unsubscribeObservable(
                criteriaItem.template.achievement_options || ""
              )
            : "";
          criteriaItem.achievement_options_tags =
            this.formatAchievementOptions(criteriaItem.achievement_options) ||
            [];
          criteriaItem.tag = "";
        });
      });
      this.tableData = tableData;
      this.oldTableData = this.unsubscribeObservable(tableData);
      return this.tableData;
    },
    unsubscribeObservable(data) {
      return JSON.parse(JSON.stringify(data));
    },
    formatAchievementOptions(achievement_options) {
      if (achievement_options === "") return [];
      let achievementOptions = achievement_options.split(",");
      let result = [];
      achievementOptions.forEach(achievement_option => {
        let achievementOption = {};
        achievementOption.text = achievement_option;
        achievementOption.tiClasses = ["ti-valid"];
        result.push(achievementOption);
      });
      return result;
    },
    isDisplay(column) {
      if (!this.columns) return true;
      return this.columns[column];
    },
    displayCriteria(category) {
      category.showCriteria = !category.showCriteria;
    },
    calcCategoryWeight(category) {
      const criteriaList = category.criteria.filter(item => item.selected);
      return criteriaList.reduce(function(sum, current) {
        return sum + parseFloat(current.weight || 0);
      }, 0);
    },
    async updateProgramTemplateCriteria(
      criteria,
      categoryIndex,
      criteriaIndex
    ) {
      if (!criteria.selected && criteria.template && criteria.template.id) {
        criteria.weight = null;
        criteria.min_point = null;
        criteria.benchmark = null;
        criteria.unit = null;
        criteria.tag = null;
        criteria.achievement_options = "";
        criteria.achievement_options_tags = [];
        await this.deleteProgramTemplateCriteria(criteria.template.id);
        criteria.template = {};
      } else {
        criteria.template = await this.saveProgramTemplateCriteria(criteria);
        this.tableData[categoryIndex].selected = true;
        this.oldTableData[categoryIndex].selected = true;
      }
      await this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("management_program_template_criteria.updated_text", {
          name: this.programTemplateInfo.name
        }),
        type: "success"
      });
      //Update oldTableData
      this.oldTableData[categoryIndex].criteria[
        criteriaIndex
      ].selected = this.unsubscribeObservable(criteria.selected);
      this.oldTableData[categoryIndex].criteria[
        criteriaIndex
      ].weight = this.unsubscribeObservable(criteria.weight);
      this.oldTableData[categoryIndex].criteria[
        criteriaIndex
      ].min_point = this.unsubscribeObservable(criteria.min_point);
      this.oldTableData[categoryIndex].criteria[
        criteriaIndex
      ].benchmark = this.unsubscribeObservable(criteria.benchmark);
      this.oldTableData[categoryIndex].criteria[
        criteriaIndex
      ].unit = this.unsubscribeObservable(criteria.unit);
      this.oldTableData[categoryIndex].criteria[
        criteriaIndex
      ].achievement_options_tags = this.unsubscribeObservable(
        criteria.achievement_options_tags
      );
    },
    async deleteProgramTemplateCriteria(templateCriteriaId) {
      return await new ProgramTemplateCriteriaService().delete(
        templateCriteriaId
      );
    },
    async deleteProgramTemplateCriteriaCategory(templateCriteriaCategoryId) {
      return await new ProgramTemplateCriteriaCategoryService().delete(
        templateCriteriaCategoryId
      );
    },
    async saveProgramTemplateCriteria(criteria) {
      const criteriaData = this.unsubscribeObservable(criteria);
      const achievementOptions = criteriaData.achievement_options_tags.map(
        ({ text }) => text
      );
      criteriaData.achievement_options = criteria.achievement_options = achievementOptions.join(
        ","
      );
      criteriaData.criterion_id = criteriaData.id;
      criteriaData.program_template_id = this.$route.params.id;
      if (criteriaData.template && criteriaData.template.id) {
        return await new ProgramTemplateCriteriaService().update(
          criteriaData.template.id,
          criteriaData
        );
      }
      delete criteriaData.id;
      return await new ProgramTemplateCriteriaService().create(criteriaData);
    },
    async updateProgramTemplateCriteriaCategory(
      criteriaCategory,
      categoryIndex
    ) {
      if (
        !criteriaCategory.selected &&
        criteriaCategory.u_t_c_c &&
        criteriaCategory.u_t_c_c.id
      ) {
        criteriaCategory.weight = null;
        await this.deleteProgramTemplateCriteriaCategory(
          criteriaCategory.u_t_c_c.id
        );
        criteriaCategory.u_t_c_c = {};
        criteriaCategory.criteria.forEach(criteriaItem => {
          criteriaItem.weight = null;
          criteriaItem.min_point = null;
          criteriaItem.benchmark = null;
          criteriaItem.unit = null;
          criteriaItem.selected = false;
          criteriaItem.tag = null;
          criteriaItem.achievement_options = "";
          criteriaItem.achievement_options_tags = [];
          criteriaItem.template = {};
        });

        this.oldTableData[categoryIndex].criteria = this.unsubscribeObservable(
          criteriaCategory.criteria
        );
      } else {
        criteriaCategory.u_t_c_c = await this.saveProgramTemplateCriteriaCategory(
          criteriaCategory
        );
      }

      this.oldTableData[categoryIndex].selected = this.unsubscribeObservable(
        this.tableData[categoryIndex].selected
      );
    },
    async saveProgramTemplateCriteriaCategory(criteriaCategory) {
      const criteriaCategoryData = this.unsubscribeObservable(criteriaCategory);
      criteriaCategoryData.criterion_category_id = criteriaCategoryData.id;
      criteriaCategoryData.program_template_id = this.$route.params.id;
      criteriaCategoryData.weight = this.calcCategoryWeight(criteriaCategory);
      delete criteriaCategoryData.id;
      return await new ProgramTemplateCriteriaCategoryService().create(
        criteriaCategoryData
      );
    },
    updateAll() {
      $(".md-actions-btn").trigger("click", function(event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
      });
    },
    compareTagOptions(a, b) {
      let leftArray = a.map(({ text }) => text);
      let rightArray = b.map(({ text }) => text);
      return this.equalsIgnoreOrder(leftArray, rightArray);
    },
    equalsIgnoreOrder(a, b) {
      if (a.length !== b.length) return false;

      const uniqueValues = new Set([...a, ...b]);
      for (const v of uniqueValues) {
        const aCount = a.filter(e => e === v).length;
        const bCount = b.filter(e => e === v).length;
        if (aCount !== bCount) return false;
      }
      return true;
    },
    displayCriteriaSaveBtn(criteria, category, categoryIndex, criteriaIndex) {
      if (!category.selected) {
        return false;
      }
      if (
        criteria.selected !==
        this.oldTableData[categoryIndex].criteria[criteriaIndex].selected
      )
        return true;
      if (
        criteria.weight !==
        this.oldTableData[categoryIndex].criteria[criteriaIndex].weight
      )
        return true;
      if (
        criteria.min_point !==
        this.oldTableData[categoryIndex].criteria[criteriaIndex].min_point
      )
        return true;
      if (
        criteria.benchmark !==
        this.oldTableData[categoryIndex].criteria[criteriaIndex].benchmark
      )
        return true;
      if (
        criteria.unit !==
        this.oldTableData[categoryIndex].criteria[criteriaIndex].unit
      )
        return true;
      return !this.compareTagOptions(
        criteria.achievement_options_tags,
        this.oldTableData[categoryIndex].criteria[criteriaIndex]
          .achievement_options_tags
      );
    },
    async getDetailProgramTemplate() {
      this.programTemplateInfo = await new ProgramTemplateService().getById(
        this.$route.params.id
      );
      this.title = this.programTemplateInfo.name;
    },
    cancel() {
      this.$router.push({ name: "ProgramTemplateList" });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/md/variables";
@import "../../../assets/scss/md/manager-program-template-criteria";
</style>
